<template>
  <div class="plugin-container" ref="elementBox">
    <div
      ref="box"
      :id="element.id"
      class="plugin-box steven-plugin-box-item" :style="style ? style :''"
    >
      <div class="plugin-box-inner-wrapper" :style="contentStyle">
        <component v-bind="$attrs" :element="element" :is="getCompName(type)"></component>
      </div>
      <div v-if="fontStyle" v-html="fontStyle"></div>
    </div>
  </div>
</template>

<script>
import EditorTable from '@/editorComponents/Table/index'
import Navigation from '@/editorComponents/Navigation/index'
import EditorPicture from '@/editorComponents/Picture/index'
import EditorText from '@/editorComponents/Text/index'
import EditorOnOff from '@/editorComponents/OnOff/index'
import EditorChart from '@/editorComponents/Chart/index'
import EditorRadio from '@/editorComponents/Radio/index'
import EditorSelect from '@/editorComponents/Select/index'
import EditorButton from '@/editorComponents/Button/index'
import EditorCheckBox from '@/editorComponents/CheckBox/index'
import EditorSwiper from '@/editorComponents/Swiper/index'
import EditorVideos from '@/editorComponents/Videos/index'
import EditorList from '@/editorComponents/List/index'
import EditorIframe from '@/editorComponents/IframeBox/index'
import EditorAnimatedNumber from '@/editorComponents/AnimatedNumber/index'
import EditorTableCarousel from '@/editorComponents/TableCarousel/index'
import EditorDate from '@/editorComponents/Date/index'
import EditorWeather from '@/editorComponents/Weather/index'
import EditorInput from '@/editorComponents/Input/index'
import EditorDatePicker from '@/editorComponents/DatePicker/index'
import DynamicPanel from '@/editorComponents/DynamicPanel/index'

import { DatasourceMaker, updateDataWithResponseResult } from '@/util/editor/datasource'
import {
  delay,
  setPromiseInterval,
  clearPromiseInterval
} from '@/util'
import { fontFamily } from '@/util/editor/fonts/fontFamily'
const apiList = window.apiList || []
export default {
  name: 'steven-plugin-box-item',
  data: function() {
    return {
      apiId: null,
      isEditing: false,
      isClearLinkage: false,
      isClearDrillDown: false,
      APIModeName: 'source',
      dataSourceUpdateing: false,
      // 组件字体配置（新增）
      fontFamilyName: null,
      fontFamilyUrl: null
    }
  },
  computed: {
    plugin: function() {
      return this.element
    },
    style() {
      var e = this.plugin.boxStyle,
          i = ['filter', 'navigation'],
          a = i.includes(this.plugin.type) ? 'visible' : 'hidden'
        'dynamicPanel' === this.plugin.type && (a = 'auto')

        var n = {
          left: e.left + 'px',
          top: e.top + 'px',
          width: e.width + 'px',
          height: e.height + 'px',
          border: e.border,
          background: this.background,
          boxShadow: this.shadow,
          zIndex: 1e3 - this.index,
          // overflow: a
        }
        if (this.plugin.type === 'bg') {
          n.width = this.editingTheme.canvasWidth + 'px'
          n.height = this.editingTheme.canvasHeight + 'px'
          n.left = 0 + 'px'
          n.top = 0 + 'px'
        }
        if (e.borderRadius && 'object' === typeof e.borderRadius) {
          var s = e.borderRadius,
              o = s.size + 'px'
          s.radius[0] && (n.borderTopLeftRadius = o),
          s.radius[1] && (n.borderTopRightRadius = o),
          s.radius[2] && (n.borderBottomRightRadius = o),
          s.radius[3] && (n.borderBottomLeftRadius = o)
        }
        return n
    },
    contentStyle() {
      return ''
    },
    // 组件字体style html代码
    fontStyle() {
      if (!this.fontFamilyName || this.fontFamilyName == '' || !this.fontFamilyUrl || this.fontFamilyUrl == '' ) return
      return `<style>
        @font-face {
          font-family: ${this.fontFamilyName};
          ${this.fontFamilyUrl !== '' ? 'src: url(' + this.fontFamilyUrl + ')' : ''}
        }
      </style>`
    },
  },
  props: ['noresize', 'index', 'type', 'element'],
  created() {
    this.$nextTick(() => {
      this.$instance[this.element.id] = this.$parent.$refs[this.element.id][0]
    })
  },
  mounted() {
    this.initCompData()
    this.handleUpdateFontStyle()
  },
  beforeDestroy() {
    clearPromiseInterval(this.createUpdateAPI)
  },
  methods: {
    initCompData() {
      if (this.element.compData && this.element.compData.apiStatusMap) {
        if (this.element.compData.data && this.element.compData.data.dataType && this.element.compData.data.dataType === 1) return
        const isAutoFetch = !!(this.element.compData.apiStatusMap[this.APIModeName] || {}).autoUpdate || false
        if (isAutoFetch) {
          const time = (this.element.compData.apiStatusMap[this.APIModeName] || {}).autoUpdate
          clearPromiseInterval(this.apiId)
          this.handleLoopFetch(time)
        } else {
          this.createUpdateAPI()
        }
      }
    },
    /**
     * 动态添加自定义字体
     */
    handleUpdateFontStyle() {
      if (!this.element.fontFamily) return
      const font = fontFamily.filter( it => it.name === this.element.fontFamily)[0]
      if (font.name == '') return
      this.fontFamilyName = font.name
      this.fontFamilyUrl = font.url
      // 废弃全局方式，改用局部v-html，需配合computed
      // this.$nextTick(() => {
      //   let style = document.createElement('style');
      //   style.type = "text/css";
      //   style.innerText = `@font-face {font-family:'${font.name}'; src:url('${font.url}')}`
      //   document.getElementsByTagName('head')[0].appendChild(style)
      // })
    },
    // 根据类型获取组件
    getCompName(type) {
      let componentName = ''
      switch (type) {
        case 'pic':
          componentName = 'EditorPicture'
          break
        case 'text':
          componentName = 'EditorText'
          break
        case 'table':
          componentName = 'EditorTable'
          break
        case 'navigation':
          componentName = 'Navigation'
          break
        case 'chart':
          componentName = 'EditorChart'
          break
        case 'onOff':
          componentName = 'EditorOnOff'
          break
        case 'radio':
          componentName = 'EditorRadio'
          break
        case 'checkBox':
          componentName = 'EditorCheckBox'
          break
        case 'select':
          componentName = 'EditorSelect'
          break
        case 'button':
          componentName = 'EditorButton'
          break
        case 'swiper':
          componentName = 'EditorSwiper'
          break
        case 'videos':
          componentName = 'EditorVideos'
          break
        case 'list':
          componentName = 'EditorList'
          break
        case 'iframeBox':
          componentName = 'EditorIframe'
          break
        case 'animatedNumber':
          componentName = 'EditorAnimatedNumber'
          break
        case 'table-carousel':
          componentName = 'EditorTableCarousel'
          break
        case 'date':
          componentName = 'EditorDate'
          break
        case 'weather':
          componentName = 'EditorWeather'
          break
        case 'input':
          componentName = 'EditorInput'
          break
        case 'datePicker':
          componentName = 'EditorDatePicker'
          break
        case 'dynamic-panel':
          componentName = 'EditorDynamicPanel'
          break
        default:
          componentName = null
          break
      }
      return componentName
    },
    // 轮询处理动态数据
    async handleLoopFetch(time) {
      if (this.element && this.element.compData && this.element.compData.advanceMode && this.element.compData.advanceMode * 1 === 1) return
      this.apiId = time && setPromiseInterval(this.createUpdateAPI, time)
    },
    createUpdateAPI() {
      let config = (this.element.compData.dataSource || {}).apiConfig || {};
      const APIModeName = this.APIModeName
      const componentId = this.element.id
      const panelFilters = (this.$EventBus || {}).panelFilters || []
      let newConfig = {}
      if (config.apiId) {
        const apiItem =  apiList.find(val => val.apiId === config.apiId)
        if (!apiItem) return
        newConfig = {
          api: apiItem.api,
          local: apiItem.local,
          apiHeaders: apiItem.headers,
          apiBody: apiItem.body,
          apiMethod: apiItem.apiType
        }
      } else {
        if (config.api === '') return
      }
      var data = {};
      data[APIModeName] = {
        dcConfig: {}
      },
      config = {
        ...config,
        ...newConfig
      }
      // 处理字段映射状态
      config.fields && (data[APIModeName].dcFields = config.fields)
      // 更新过滤器开关
      data[APIModeName].dcConfig.useFilter = !!config.useFilter
      data[APIModeName].dcConfig.pageFilters = config.pageFilters
      const hasConfig = config[config.type] || null
      this.dataSourceUpdateing = true
      if (config.type !== 'static' && !config.api ) return
      var datasource = new DatasourceMaker(componentId, data, config, panelFilters);
      datasource[APIModeName](this.createUpdateAPIStatusCallback(componentId, APIModeName, data))
    },
    /**
     * 更新API状态回调
     * a => "tab-list_IU67K"
     * b => "source"
     * c => { source: { dcConfig: {}, dcFields: {} }}
     */
    createUpdateAPIStatusCallback(a, b, c) {
      var d = this,
          _this = this
      return function(APIModeName, result, log) {
          // 更新 apiStatusMap，面板数据状态
          console.group('createUpdateAPIStatusCallback')
          console.log(APIModeName, '// APIModeName')
          console.log(result, '// result')
          console.log(log, '// log')
          console.groupEnd();
          // debugger  // steven debugger
          _this.element.compData.apiStatusMap[APIModeName].response = result || []
          updateDataWithResponseResult(_this.element, APIModeName)
          _this.dataSourceUpdateing = false
      }
    },
  },
  components: {
    EditorTable,
    EditorPicture,
    EditorText,
    EditorChart,
    Navigation,
    EditorOnOff,
    EditorRadio,
    EditorSelect,
    EditorButton,
    EditorCheckBox,
    EditorSwiper,
    EditorVideos,
    EditorList,
    EditorIframe,
    EditorAnimatedNumber,
    EditorTableCarousel,
    EditorDate,
    EditorWeather,
    EditorInput,
    EditorDatePicker,
    EditorDynamicPanel: DynamicPanel
  }
}
</script>

<style lang="less" scoped>
// Color variables (appears count calculates by raw css)
@color0: #ffc800; // Appears 6 times
@color3: #25AEAB; // Appears 6 times
@width0: 100%; // Appears 2 times
@width2: 0; // Appears 2 times
@height0: 100%; // Appears 2 times
@height2: 0px; // Appears 2 times
.plugin-box {
  position: absolute;
  left: 30%;
  top: 30%;
  height: 40%;
  width: 40%;
  box-sizing: border-box;
  // overflow: hidden;
}

.plugin-box-cover-layer {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 101;
}

.plugin-box:hover > .plugin-box-cover-layer {
  // border: solid 1px rgba(255, 255, 255, 0.1);
  border: 1px dashed @color0;
  box-sizing: border-box;
}

.plugin-box-inner-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.plugin-box-line {
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  z-index: 1000;
}
.plugin-box-scale {
  -webkit-user-drag: none;
  background: @color0;
  box-sizing: border-box;
  pointer-events: auto;
  position: absolute;
  z-index: 10000;
  border: 1px solid #000;
  width: 9px;
  height: 9px;
  &:hover {
    background: @color3;
  }
  &:active {
    background: @color3;
  }
}
.plugin-box-scale.topleft {
  cursor: nw-resize;
  left: -4px;
  top: -4px;
}
.plugin-box-scale.top {
  cursor: n-resize;
  left: 50%;
  margin-left: -3px;
  top: -4px;
}
.plugin-box-scale.topright {
  cursor: ne-resize;
  right: -4px;
  top: -4px;
}
.plugin-box-scale.right {
  cursor: e-resize;
  margin-top: -3px;
  right: -4px;
  top: 50%;
}
.plugin-box-scale.bottomright {
  bottom: -4px;
  cursor: se-resize;
  right: -4px;
}
.plugin-box-scale.bottom {
  bottom: -4px;
  cursor: s-resize;
  left: 50%;
  margin-left: -3px;
}
.plugin-box-scale.bottomleft {
  bottom: -4px;
  cursor: sw-resize;
  left: -4px;
}
.plugin-box-scale.left {
  cursor: w-resize;
  left: -4px;
  margin-top: -3px;
  top: 50%;
}
.box-line {
  position: absolute;
}
.box-line.locking {
    border-color: gray;
}
.box-line.editing {
    border-color: red;
}
.box-line.top-line {
    border-top: dashed 1px @color0;
    height: @height2;
    left: 0;
    top: -1px;
    width: @width0;
}
.box-line.right-line {
    border-right: dashed 1px @color0;
    height: @height0;
    right: -1px;
    top: 0px;
    width: @width2;
}
.box-line.bottom-line {
    border-bottom: dashed 1px @color0;
    bottom: -1px;
    height: @height2;
    left: 0;
    width: @width0;
}
.box-line.left-line {
    border-left: dashed 1px @color0;
    height: @height0;
    left: -1px;
    top: 0px;
    width: @width2;
}
</style>
